var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.994 1.817a5.75 5.75 0 0 0-4.045 1.614l-.008.007-1.72 1.71a.75.75 0 1 0 1.058 1.064l1.716-1.706a4.25 4.25 0 0 1 6.01 6.008L17.01 13.51a4.25 4.25 0 0 1-6.41-.46.75.75 0 1 0-1.2.9 5.75 5.75 0 0 0 8.67.62l3-3 .01-.009a5.75 5.75 0 0 0-4.086-9.744M10.407 8.76a5.75 5.75 0 0 0-4.477 1.67l-3 3-.01.009a5.75 5.75 0 0 0 8.131 8.13l.01-.009 1.71-1.71a.75.75 0 0 0-1.061-1.06l-1.706 1.705a4.25 4.25 0 0 1-6.009-6.01L6.99 11.49a4.25 4.25 0 0 1 6.41.46.75.75 0 1 0 1.2-.9 5.75 5.75 0 0 0-4.193-2.29",
    clipRule: "evenodd"
  })));
};
export default SvgLink;